module.exports = __webpack_public_path__ + "img/mobile.fcbe000c.png";